<template>
  <div :key="key" class="dashboard-chart">
    <h4>Diferencia de Plazos</h4>
    <!-- :separator-step="parseInt(indicadorPlazosObjetivo)" -->
    <vue-svg-gauge
      :start-angle="-110"
      :end-angle="110"
      :value="indicadorPjeObjetivo"
      :separator-step="0"
      :min="indicadorPlazosMin"
      :max="indicadorPlazosMax"
      :gauge-color="indicadorPlazosColor"
      :scale-interval="10"/>
    <div class="dashboard-chart-text">
      <p>Plazo Objetivo: {{ indicadorPlazosObjetivo }} días</p>
      <p>Plazo Actual: {{ indicadorPlazosActual }} días</p>
      <p v-if="indicadorPlazosObjetivo != 0">Pje Actual: {{ indicadorPjeObjetivo | numero(2, true) }} %</p>
      <p v-if="indicadorPlazosObjetivo == 0">Pje Actual: -- %</p>
      <!-- <p>Plazo Objetivo: {{ indicadorPlazosObjetivo | numero(2, true) }} días</p>
      <p>Plazo Actual: {{ indicadorPlazosActual | numero(2, true) }} días</p> -->
      <p class="description">{{ indicadorPlazosDescripcion }}</p>
    </div>
  </div>
</template>

<script>
import { VueSvgGauge } from 'vue-svg-gauge';

export default {
  components: {
    VueSvgGauge,
  },
  data() {
    return {
      rojo: '#E46651',
      verde: '#41B883',
      amarillo: '#FAFA05',
      rosa: '#FF0187',

      key: 0,
      indicadorPlazosActual: 0,
      indicadorPlazosObjetivo: parseInt(0),
      indicadorPlazosMin: 0,
      indicadorPlazosMax: 100,
      indicadorPlazosColor:  [ { offset: 0, color: '#E46651' }, { offset: 100, color: '#E46651' } ],
      indicadorPlazosDescripcion: '',
      indicadorPjeObjetivo: 0,
    }
  },
  created() {
  },
  methods: {
    getIndicador() {
      this.$store.dispatch('resultadosAdministracion/getIndicadorDiferenciaPlazos')
        .then(() => {
          let indicador = this.$store.getters['resultadosAdministracion/indicadorDiferenciaPlazos']

          this.indicadorPlazosActual = +(Math.round(indicador.plazoActual + "e+2")  + "e-2");
          this.indicadorPlazosObjetivo = parseFloat(indicador.plazoObjetivo);
          this.indicadorPlazosMax = indicador.plazoActual > 100 ? indicador.plazoActual : 100;
          this.indicadorPlazosDescripcion = indicador.indicadorPeriodo? indicador.indicadorPeriodo.trim() : '';
          this.indicadorPjeObjetivo = parseFloat(indicador.pjeObjetivo);

          // if (parseFloat(this.indicadorPjeObjetivo) >= parseFloat(110)) {
          //   this.indicadorPlazosColor = [{ offset: 0, color: this.rosa }, { offset: 100, color: this.rosa }];
          // } else 
          if (parseFloat(this.indicadorPjeObjetivo) >= parseFloat(100)) {
            this.indicadorPlazosColor = [{ offset: 0, color: this.verde }, { offset: 100, color: this.verde }];
          } else if (parseFloat(this.indicadorPjeObjetivo) > parseFloat(50)) {
            this.indicadorPlazosColor = [{ offset: 0, color: this.amarillo }, { offset: 100, color: this.amarillo }];
          }
        })
        .finally(() => this.key++);
    },
    cancelar() {
      this.$store.dispatch('resultadosAdministracion/cancelarIndicadorDiferenciaPlazos');
    },
  }
}
</script>

<style>
</style>


